import React, { useState } from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { FiSearch, FiPlay, FiCpu, FiBook, FiZap, FiCheck, FiLoader } from 'react-icons/fi';

const formatIcon = { Video: FiPlay, Interactive: FiCpu, Course: FiBook, 'Micro-learning': FiZap };
const diffColor = { Beginner: 'text-green-600 bg-green-50', Intermediate: 'text-yellow-600 bg-yellow-50', Advanced: 'text-red-600 bg-red-50' };

const StepModules = ({ form, update, modules, loading }) => {
  const [search, setSearch] = useState('');
  
  // Convert all items to string for robust comparison (handles integer vs string mismatch from API JSON)
  const trainingContentStrings = (form.trainingContent || []).map(String);

  const toggle = (id) => {
    const stringId = String(id);
    const isSelected = trainingContentStrings.includes(stringId);
    
    const newSelected = isSelected
      ? form.trainingContent.filter(x => String(x) !== stringId)
      : [...form.trainingContent, id]; // preserve original type when adding
      
    update({ trainingContent: newSelected });
  };

  const filtered = (modules || []).filter(m =>
    (m.title || '').toLowerCase().includes(search.toLowerCase()) ||
    (m.category || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div>
        <p className="text-sm font-semibold text-slate-700 mb-1">Select Training Modules <span className="text-red-500">*</span></p>
        <p className="text-xs text-slate-500 mb-3">{form.trainingContent.length} module{form.trainingContent.length !== 1 ? 's' : ''} selected</p>
        <div className="relative mb-3">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search modules…"
            className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500" />
        </div>
      </div>

      <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-8 text-slate-500">
            <SafeIcon icon={FiLoader} className="animate-spin text-2xl mb-2" />
            <p className="text-sm mt-2">Loading modules...</p>
          </div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-8 text-slate-500 text-sm">
            No modules found.
          </div>
        ) : (
          filtered.map(m => {
            const Icon = formatIcon[m.deliveryFormat] || FiBook;
            const selected = trainingContentStrings.includes(String(m.id));
            
            return (
              <div key={m.id} onClick={() => toggle(m.id)}
                className={`flex items-start gap-3 p-3 rounded-xl border cursor-pointer transition-all ${selected ? 'border-blue-500 bg-blue-50' : 'border-slate-200 bg-white hover:border-blue-300 hover:bg-slate-50'}`}>
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${selected ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-500'}`}>
                  {selected ? <SafeIcon icon={FiCheck} /> : <SafeIcon icon={Icon} />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-semibold ${selected ? 'text-blue-700' : 'text-slate-800'}`}>{m.title}</p>
                  <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                    <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${diffColor[m.difficultyLevel] || diffColor.Beginner}`}>{m.difficultyLevel}</span>
                    <span className="text-xs text-slate-400">{m.deliveryFormat} · {m.duration}</span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default StepModules;